import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import * as Func from '../../../../helpers/functions';
import action from '../../../../actions/index';
import * as GroupComponent from './component/CommonComponent';
import Model from '../../../../constants/Model';
import * as HMS from "../../common/component/Index";
import i18n from "../../../../constants/initLng";
import { FlagIcons } from '../../common/component/TranslateButton';
import Group from './../../../../models/Group';
import moment from 'moment';
import DEFINE, { FEATURE_FLAGS, CURRENCY, ALL_CURRENCY_ENUM, TRANSLATE_LANGUAGE } from "../../../../constants/Define";
import * as ANT from 'antd';
import Span from '../../common/component/Span';
import { find, toArray } from 'lodash';
import EllipsisText from '../../common/component/EllipsisText';

let permissionActions = [];
const ModelFields = Object.getOwnPropertyNames(new Group());
class Groups extends Component {
    state = {
        titleTable: Func.getTitleTable(Model.GroupsModel.titleTable, ['action'], ['id', 'voucherType']),
        modelGroup: ModelFields,
        componentTable: {
            name: {
                key: 'name',
                width: 300,
                sorter: (i, k) => i.name.length - k.length,
                fixed: 'left',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
            },
            groupCode: {
                width: 150,
                key: 'groupCode',
                sorter: (i, k) => (i.groupCode || '').length - k.length,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            remainVouchers: {
                // sorter: (i, k) => i.remainVouchers.length - k.length,
                render: (text, record) => {
                    const allCurrency = find(record.remainVouchers, item => item.currencyCode === ALL_CURRENCY_ENUM);
                    return allCurrency.remain;
                },
                align: 'right',
            },
            saleStartDate: {
                sorter: (i, k) => i.saleStartDate.length - k.length,
                render: (text, record) => moment(moment.utc(text).toDate()).format('DD-MM-YYYY HH:mm'),
            },
            saleEndDate: {
                sorter: (i, k) => i.saleEndDate.length - k.length,
                render: (text, record) => moment(moment.utc(text).toDate()).format('DD-MM-YYYY HH:mm'),
            },
            startDate: {
                sorter: (i, k) => i.startDate.length - k.length,
                render: (text, record) => moment(new Date(text)).format('DD-MM-YYYY'),
            },
            endDate: {
                sorter: (i, k) => i.endDate.length - k.length,
                render: (text, record) => moment(new Date(text)).format('DD-MM-YYYY'),
            },
            bookingPeriod: {
                sorter: (i, k) => i.bookingPeriod.length - k.length,
                render: (text, record) => moment(new Date(text)).format('DD-MM-YYYY'),
            },
            originalPrice: {
                align: 'left',
                render: (text, record) => <Span className="prices">
                    <Span className={record.salePrice ? "prices-sale" : ''}>{Func.formatMoney(text)}</Span>{`${Func.formatMoney(record.salePrice)}${this.props.t(`currencySymbol`)}`}
                </Span>
            },
            minOrderValue: {
                align: 'right',
                render: (text, record) => Func.formatMoney(text),
            },
            numberOfBookingPeriod: {
                align: 'right',
            },
            maxOrderValue: {
                align: 'right',
                render: (text, record) => Func.formatMoney(text),
            },
            limitNumberOfSalesPerUser: {
                align: 'right',
            },
            maxDiscountValue: {
                align: 'right',
                render: (text, record) => Func.formatMoney(text),
            },
            discountValue: {
                sorter: (a, b) => a.discountValue - b.discountValue,
                render: (text, record) => {
                    switch (record.voucherType) {
                        case DEFINE.GENERAL.VOUCHER_TYPE.GIFT:
                            return this.props.t(`item.group.${DEFINE.GENERAL.VOUCHER_TYPE.GIFT}`);
                        case DEFINE.GENERAL.VOUCHER_TYPE.PERCENT:
                            return `${text}%`;
                        case DEFINE.GENERAL.VOUCHER_TYPE.MONEY:
                            return `${Func.formatMoney(text.toString())}`;
                        default:
                            return "---";
                    }
                },
            },
            properties: {
                width: 100,
                render: (text, record) => (
                    <ANT.Tooltip placement="right" title={() => <HMS.ToolTipData data={text} />}>
                        <ANT.Button>{text.length}</ANT.Button>
                    </ANT.Tooltip>
                ),
            },
            isAvailable: {
                title: this.props.t('item.group.available'),
                key: 'isAvailable',
                render: (status) => <HMS.StatusComponent color={status ? 'green' : 'red'}
                    label={status ? i18n.t('item.group.isAvailable') : i18n.t('item.group.isUnAvailable')} />,
                filters: [
                    { value: true, text: this.props.t('item.group.isAvailable') },
                    { value: false, text: this.props.t('item.group.isUnAvailable') }
                ],
                filterMultiple: false,
            },
            order: {
                sorter: (i, k) => i.order.length - k.length,
                render: (text, record) => text
            },
            translations: {
                render: (text, record) => <FlagIcons languages={record.translations} />,
                key: 'languageCode',
                filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                    value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                })),
                filterMultiple: false,
            },
            action: {
                width: 90,
                fixed: 'right',
                align: 'center',
                render: (text, record) => <GroupComponent.EditComponent item={record} permissionActions={permissionActions}
                    onDeleteGroup={this.props.onDeleteGroup} onCloneGroup={this.props.onCloneGroup} />,
            }
        },
        groups: [],
        pageSize: this.props.groups.data.pageSize,
        pageIndex: this.props.groups.data.pageIndex,
        totalCount: this.props.groups.data.totalCount,
        totalPage: this.props.groups.data.totalPage,
        isFetching: false,
        filter: {}
    };

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.GROUP);
        this.setState({
            pageSize: this.props.groups.data.pageSize,
            pageIndex: this.props.groups.data.pageIndex,
            totalCount: this.props.groups.data.totalCount,
            totalPage: Math.ceil(parseInt(this.props.groups.data.totalCount) / parseInt(this.props.groups.data.pageSize))
        })
        this.props.onListGroup({ pageSize: this.props.groups.data.pageSize, pageIndex: this.props.groups.data.pageIndex });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isFetching: nextProps.groups.isFetching,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.groups.data !== prevProps.groups.data) {
            this.setState({
                groups: this.props.groups.data.result,
                pageSize: this.props.groups.data.pageSize,
                pageIndex: this.props.groups.data.pageIndex,
                totalCount: this.props.groups.data.totalCount,
                totalPage: Math.ceil(parseInt(this.props.groups.data.totalCount) / parseInt(this.props.groups.data.pageSize))
            })
        }
    }

    onChangeLanguage = (language) => {
        this.props.onListGroup({ pageSize: this.props.groups.data.pageSize, pageIndex: this.props.groups.data.pageIndex });
    }

    onChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.onListGroup(newFilters);
    };

    render() {
        const { t } = this.props;
        const { totalPage, titleTable, groups, modelGroup, isFetching, totalCount, pageIndex, pageSize, componentTable, } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'groups'}
                        titleHeader={t('navigation.groups')}
                        componentRight={
                            <Fragment>{
                                permissionActions && permissionActions.allowCreate &&
                                <Link to={`/groups/action`}
                                    className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            }
                            </Fragment>
                        }
                    />
                    <HMS.ListComponent
                        tableKey="group-list"
                        scroll={{ x: 2650 }}
                        rowKey={record => record.id}
                        loading={{ spinning: isFetching, size: 'large' }}
                        dataSource={Func.getDataSource(groups, modelGroup)}
                        columns={Func.columnsTable({
                            titleTable: titleTable,
                            component: componentTable,
                            itemName: 'group'
                        })}
                        onChange={this.onChange}
                        pagination={{ total: totalCount, totalPage: totalPage, pageSize, current: pageIndex }}
                        componentTableList={{
                            // right: <Fragment>{
                            //     permissionActions && permissionActions.allowCreate &&
                            //     <Link to={`/groups/action`}
                            //         className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            // }
                            // </Fragment>
                        }}
                        classChildren="group-list p-0" classParent="m-0"
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        groups: state.groupReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListGroup: (filters) => {
            dispatch(action.dataGroupAction(filters))
        },
        onDeleteGroup: (id) => {
            dispatch(action.deleteGroupAction(id))
        },
        onCloneGroup: (id) => {
            dispatch(action.cloneGroupAction(id))
        }
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Groups));
